export enum AuthStateEvent {
  Unload = 'auth-unload',
  Init = 'auth-init',
  Process = 'auth-process',
  Success = 'auth-success',
  Error = 'auth-error',
}
